// extracted by mini-css-extract-plugin
module.exports = {"regardingAnyContainer":"style_regardingAnyContainer__3-NcR"};